import { useState, useCallback, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'
import { updateOpportunityNextActionDate } from '../api'
import { IOpportunityNextActionDateUpdate } from '../typings'

export const useUpdateOpportunityNextActionDate = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const [toUpdate, setToUpdate] = useState<IOpportunityNextActionDateUpdate>()

  const execute = useCallback(
    (update: IOpportunityNextActionDateUpdate) => {
      if (status != 'pending') {
        setToUpdate(update)
      }
    },
    [status],
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (toUpdate) {
        try {
          setStatus('pending')
          const result = await dispatch(
            updateOpportunityNextActionDate(toUpdate),
          )

          if (mounted) {
            if (updateOpportunityNextActionDate.fulfilled.match(result)) {
              setStatus('success')
              //toast.success('Lead next action date updated')
            } else {
              setStatus('fail')
              toast.error(`Unable to update opportunity next action date.`)
            }
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
            toast.error(error.Message)
          }
        } finally {
          setToUpdate(undefined)
          setStatus('idle')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, toUpdate])

  return { status, execute }
}
